<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>CMS Custom Field</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'Home'}">Home</router-link>
              </li>
              <li class="breadcrumb-item active">CMS Custom Field</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="CMSCustomField">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{name: 'CMSCustomFieldList'}"><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group required">
                    <label class="control-label">Field Name</label>
                    <input type="text" id="field_name" name="field_name"
                           v-bind:class="{'has-error' : errors.has('field_name')}"
                           v-validate="'required'"
                           v-model="value.field_name" class="form-control field_name"
                           placeholder="Field Name">
                    <div class="help text-danger" v-show="errors.has('field_name')">
                      {{ errors.first("field_name") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Page</label>
                    <multiselect id="page_id" name="page_id" :options="Object.keys(pre.page_id)"
                                 :custom-label="opt => pre.page_id[opt]"
                                 v-bind:class="{'has-error' : errors.has('page_id')}"
                                 v-validate="'required'"
                                 v-model="value.page_id" class="page_id"
                                 placeholder="Select Page" :searchable="true"
                                 :close-on-select="true" :show-labels="false"></multiselect>
                    <div class="help text-danger" v-show="errors.has('page_id')">
                      {{ errors.first("page_id") }}
                    </div>
                  </div>
                  <div class="form-group ">
                    <label class="control-label">Field Type</label>
                    <select class="form-control" style="width: 100%;"
                            name="field_type" v-model="value.field_type" id="field_type">
                      <option value="Text">Text</option>
                      <option value="Textarea">Textarea</option>
                      <option value="Repeater">Repeater</option>
                    </select>
                  </div>


                  <div>
                    <h4 class="site-heading my-3"><span>CMS Custom Field Details</span></h4>

                    <div class="form-row align-items-end"
                         v-for="(cms_custom_field_detail, index) in value.cms_custom_field_details">

                      <div class="form-group col-md-11 required">
                        <label class="control-label">Field Label</label>
                        <input type="text" id="cms_custom_field_detail.field_label"
                               name="cms_custom_field_detail.field_label"
                               v-bind:class="{'has-error' : errors.has('cms_custom_field_detail.field_label')}"
                               v-validate="'required'"
                               v-model="cms_custom_field_detail.field_label"
                               class="form-control cms_custom_field_detail.field_label"
                               placeholder="Field Label">
                        <div class="help text-danger" v-show="errors.has('cms_custom_field_detail.field_label')">
                          {{ errors.first("cms_custom_field_detail.field_label") }}
                        </div>
                      </div>
                      <div class="form-group col-md-11 required">
                        <label class="control-label">Field Type</label>

                        <select class="form-control" style="width: 100%;"
                                id="cms_custom_field_detail.field_type"
                                name="cms_custom_field_detail.field_type"
                                v-bind:class="{'has-error' : errors.has('cms_custom_field_detail.id')}"
                                v-validate="'required'"
                                v-model="cms_custom_field_detail.field_type"
                        >
                          <option value="Text">Text</option>
                          <option value="Textarea">Textarea</option>
                          <option value="Repeater">Repeater</option>
                        </select>
                        <div class="help text-danger" v-show="errors.has('cms_custom_field_detail.field_type')">
                          {{ errors.first("cms_custom_field_detail.field_type") }}
                        </div>
                      </div>
                      <div class="form-group col-md-1">
                        <button type="button" class="btn btn-danger float-right"
                                @click="deleteCms_custom_field_detail(index)"><i
                          class="fa fa-trash"></i>
                        </button>
                      </div>
                      <div class="clearfix"></div>
                      <div class="col-12">
                        <hr class="dotted">
                      </div>

                    </div>
                    <button type="button" @click="addCms_custom_field_detail" class="btn btn-success"><i
                      class="fa fa-plus"></i> New
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">Submit</button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import {DepartmentsAPI, CommonAPI} from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "CMSCustomFieldForm",
  metaInfo: {
    title: "CMS Custom Field | Dotlines"
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
      cms_custom_field_details: [],

    },
    pre: {
      page_id: {},
    }
  }),
  methods: {
    addCms_custom_field_detail: function () {
      this.value.cms_custom_field_details.push({});
    },

    deleteCms_custom_field_detail: function (index) {
      this.value.cms_custom_field_details.splice(index, 1)
    },

    pageIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios.get("/get-dropdown-options/1")
          .then(response => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/cms_custom_fields";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/cms_custom_fields/" + _this.$route.params.id
            method = "PUT";
          }


          axios({
            method: method, url: api_url,
            data: _this.value,
            headers: {"Content-Type": "application/json"},
          }).then(function (response) {
            _this.$toaster.success(response.data.message);
            _this.$router.push({"name": "CMSCustomFieldList"});
          }).catch((errors) => {
            if (errors.response.status === 500) {
              _this.$toaster.error(errors.response.data.message);
            }
            _this.$setErrorsFromResponse(errors.response.data);
          }).finally(() => {
            _this.is_loading = false;
          });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/cms_custom_fields/" + id;
        axios.get(api_url)
          .then(response => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.pageIdOptions().then(page_id => {
        this.pre.page_id = page_id;
      });

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id).then(response => {
          this.value = response.data;
        }).catch((error) => {
          console.log(error.response);
        });


      }

      this.is_loading = false;
    }
  },
  mounted() {
    this.initialize()
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
}
</script>
<style scoped>
hr.solid {
  border-top: 3px solid #333;
  width: 100%;
}
</style>

